export default __webpack_public_path__ + "static/media/Product-upload-sample.8d97d7a1.xlsx";